


























import { Component, Vue } from "vue-property-decorator";
@Component
export default class TopToolbar extends Vue {
  showMenu = false;
  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }
}
